document.addEventListener('DOMContentLoaded', function () {

    const setHeaderCartIconAccessibility = () => {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            open();
        });
    }

    const open = () => {
        document.querySelector('.bona-drawer').classList.add('active');
        hiddenOverflow();
    }

    const hiddenOverflow = () => {
        if (document.querySelector('.bona-drawer.active')) {
            document.body.style.height = '100vh';
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.height = '';
            document.body.style.overflowY = '';
        }
    }

    const close = () => {
        document.querySelector('.bona-drawer').classList.remove('active');
        hiddenOverflow();
    }

    const closeModal = () => {
        document.addEventListener('keyup', (event) => event.code == 'Escape' && close());
        document.querySelector('.bona-modal__backdrop').addEventListener('click', () => {
            close();
        });
        document.querySelector('#close-modal-btn').addEventListener('click', () => {
            close();
        })
    }

    closeModal();
    setHeaderCartIconAccessibility();

    const getSectionsToRender = () => {
        return [
            {
                id: 'bona-modal-cart',
                section: 'cart-drawer',
                selector: '.bona-modal__container'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            }
        ];
    }

    const getSectionInnerHTML = (html, selector) => {
        const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
        const selectedElement = parsedDoc.querySelector(selector);

        return selectedElement ? selectedElement.innerHTML : '';
    }

    const updateQuantity = async (line, quantity) => {
        enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity: quantity,
            sections: getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
    
        try {
            const response = await fetch('/cart/change.js', {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                ...{ body }
            });
            const state = await response.text();
            const parsedState = JSON.parse(state);

            getSectionsToRender().forEach((section) => {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                if (elementToReplace) {
                    elementToReplace.innerHTML =
                        getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
            });
            reattachEventListeners();
            closeModal()
        } catch (error) {
            console.error("Error removing item from cart:", error);
        } finally {
            disableLoading(line);
        }
    }

    const enableLoading = (line) => {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('bonaCartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartDrawerItemElements = document.querySelectorAll(`#bonaCartDrawer-Item-${line} .loading-overlay`);

        [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
        document.activeElement.blur();
    }

    const disableLoading = (line) => {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('bonaCartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');

        const cartDrawerItemElements = document.querySelectorAll(`#bonaCartDrawer-Item-${line} .loading-overlay`);

        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }

    function QuantityInput(element) {
        const input = element.querySelector('input');
        const changeEvent = new Event('change', { bubbles: true });

        const onInputChange = () => validateQtyRules();

        const onButtonClick = (event) => {
            event.preventDefault();
            const previousValue = input.value;

            event.currentTarget.name === 'plus' ? input.stepUp() : input.stepDown();
            if (previousValue !== input.value) input.dispatchEvent(changeEvent);
        };

        const validateQtyRules = () => {
            const value = parseInt(input.value, 10);

            if (input.min) {
                const min = parseInt(input.min, 10);
                const buttonMinus = element.querySelector(".bona-quantity-button[name='minus']");
                buttonMinus.classList.toggle('disabled', value <= min);
            }

            if (input.max) {
                const max = parseInt(input.max, 10);
                const buttonPlus = element.querySelector(".bona-quantity-button[name='plus']");

                buttonPlus.classList.toggle('disabled', value >= max);
            }
        }

        input.addEventListener('change', () => {
            onInputChange();
            const line = input.getAttribute('data-index');
            let quantity = parseInt(input.value, 10);
            updateQuantity(line, quantity);
        });
        element.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', onButtonClick)
        );

        validateQtyRules();
    }

    const reattachEventListeners = () => {
        document.querySelectorAll('.cart-remove-button').forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const line = button.getAttribute('data-index');
                updateQuantity(line, 0);
            });
        });

        document.querySelectorAll('quantity-input').forEach((element) => {
            QuantityInput(element);
        })
    }

    reattachEventListeners();
});
